module.exports = __webpack_public_path__ + "img/T7450-ST.7d804cab.jpg";